import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../ui'
import { ButtonsBlock } from '../../../Edit/components'

import style from './style.m.less'
import { QuestionCircle } from '../../../../assets/icons'

interface ICloseEditModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
}

const CloseEditModal: FC<ICloseEditModal> = ({ isModalVisible, setIsModalVisible }) => {
    const { t } = useTranslation()

    const navigate = useNavigate()

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const getBack = () => {
        navigate(-1)
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.modalWrapper}>
                <div className={style.headerWrapper}>
                    <QuestionCircle />
                    <div className={style.header}>{t('editMyProfile.exitWithoutSaving')}?</div>
                </div>
            </div>
            <div className={style.text}>{t('editMyProfile.closeEditText')}</div>
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    confirmAction={getBack}
                    cancelAction={handleOk}
                    confirmTitle={t('editMyProfile.exitWithoutSaving')}
                />
            </div>
        </Modal>
    )
}

export default CloseEditModal
